// src/utils/payments.js
// --- Cloud Run endpoints (LIVE) ---
const CREATE_ORDER_URL   = "https://createorder-cg22cylv2a-uc.a.run.app";
const VERIFY_PAYMENT_URL = "https://verifypayment-cg22cylv2a-uc.a.run.app";
const GET_DOWNLOAD_URL   = "https://getdownloadurl-cg22cylv2a-uc.a.run.app";

// ---- helpers ----
async function readAsJsonSafe(resp) {
  const text = await resp.text().catch(() => "");
  try {
    return JSON.parse(text);
  } catch {
    return { raw: text };
  }
}

function ensureNumber(n) {
  const x = typeof n === "number" ? n : parseFloat(String(n).replace(/[^\d.]/g, ""));
  if (!Number.isFinite(x)) throw new Error("Invalid amount");
  return x;
}

// Create order (send rupees; server converts to paise)
export async function createRazorpayOrder(amount, notes = {}) {
  const rupees = ensureNumber(amount);

  const resp = await fetch(CREATE_ORDER_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({ amount: rupees, notes }),
  });

  const data = await readAsJsonSafe(resp);
  if (!resp.ok) {
    const msg = (data && (data.error || data.message)) || data.raw || `Failed: HTTP ${resp.status}`;
    throw new Error(msg);
  }

  // Expecting { id, amount, currency, ... }
  return data;
}

// Verify payment on the server (signature + optional payment fetch)
// accepts optional { keepalive } to let the request continue during navigation
export async function verifyRazorpayPayment(
  { razorpay_payment_id, razorpay_order_id, razorpay_signature },
  opts = {}
) {
  const payload = {
    payment_id: razorpay_payment_id,
    order_id: razorpay_order_id,
    signature: razorpay_signature,
  };

  const resp = await fetch(VERIFY_PAYMENT_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify(payload),
    keepalive: !!opts.keepalive, // lets the request finish even if we navigate
  });

  const data = await readAsJsonSafe(resp);
  if (!resp.ok) {
    const msg = (data && (data.error || data.message)) || data.raw || `Verification failed: HTTP ${resp.status}`;
    throw new Error(msg);
  }

  // Expecting { verified: true, status: "captured", ... }
  return data;
}

// Ask backend for a short-lived signed URL (auto-download on ThankYou page)
export async function getSignedDownloadUrl(paymentId) {
  if (!paymentId) throw new Error("Missing payment id");

  const resp = await fetch(GET_DOWNLOAD_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({ paymentId }),
  });

  const data = await readAsJsonSafe(resp);
  if (!resp.ok) {
    const msg = (data && (data.error || data.message)) || data.raw || `Could not get download link (HTTP ${resp.status})`;
    throw new Error(msg);
  }

  // Expecting { url }
  return data;
}
